import { ActivatedRouteSnapshot, BaseRouteReuseStrategy, Params } from "@angular/router";

export class ExplicitQueryParamsReactivateStrategy extends BaseRouteReuseStrategy {
  public override shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot
  ): boolean {
    return (
      super.shouldReuseRoute(future, curr) &&
      !this.trackedQueryParamsChanged(future, curr)
    );
  }

  private trackedQueryParamsChanged(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot
  ): boolean {
    const trackedQueryParams = this.getTrackedQueryParams(future);

    const trackedFutureParams = this.filterQueryParams(
      future.queryParams,
      trackedQueryParams
    );

    const trackedCurrParams = this.filterQueryParams(
      curr.queryParams,
      trackedQueryParams
    );

    return this.queryParamsChanged(trackedFutureParams, trackedCurrParams);
  }

  private getTrackedQueryParams(route: ActivatedRouteSnapshot): string[] {
    const { trackedQueryParams } = route.data;

    if (typeof trackedQueryParams === "string") {
      return [trackedQueryParams];
    }

    if (Array.isArray(trackedQueryParams)) {
      return trackedQueryParams;
    }

    return [];
  }

  private filterQueryParams(queryParamMap: Params, queryParamKeys: string[]): Params {
    if (queryParamKeys.length === 0) {
      return {};
    }

    return Object.fromEntries(
      Object.entries(queryParamMap).filter(([queryParamKey]) => {
        return queryParamKeys.includes(queryParamKey);
      })
    );
  }

  private queryParamsChanged(future: Params, curr: Params): boolean {
    const futureParamList = Object.entries(future);
    const currParamList = Object.entries(curr);

    if (futureParamList.length !== currParamList.length) {
      return true;
    }

    for (const [paramKey, futureParamValue] of futureParamList) {
      const currParamValue = curr[paramKey];
      if (futureParamValue !== currParamValue) {
        return true;
      }
    }

    return false;
  }
}
